import { call, put, select, takeEvery } from "redux-saga/effects";
import { getUserUidSelector } from "../../app/appSelectors";
import { getRequest, postRequest } from "../../app/request";
import { referralSlice } from "./referralReducer";
import { failurePut } from "../../app/failurePut";
import { getReferralQRCodeSelector, getReferralLinkSelector } from "./referralSelectors";
import QRCode from "qrcode";
import { IQueryParamsReferralsPayload } from "./referral.t";
import { locationSlice } from "../Location/locationReducer";
import { LOCATION_NAMES } from "../Location/locationConstants";

export function* getReferralCodeSaga() {
    try {
        const uid = yield select(getUserUidSelector);
        const resp = yield call(postRequest, '/referral/code', { uid });
        yield put(referralSlice.actions.getReferralCodeSuccess(resp.code));

        const { host } = window.location;
        const referralLink = `${host}/app/registration?refcode=${resp.code}`;

        yield put(referralSlice.actions.getReferralLinkSuccess(referralLink));
    } catch (e) {
        yield call(failurePut, e, referralSlice.actions.getReferralCodeError);
    }
}

export function* getReferralInvitedFriendsSaga({ payload }: { payload: IQueryParamsReferralsPayload }) {
    try {
        const { page, pageSize } = payload;
        const resp = yield call(getRequest, `/referral/invited-friends?page=${page}&pageSize=${pageSize}`);
        yield put(referralSlice.actions.getReferralInvitedFriendsSuccess(resp));
    } catch (e) {
        yield call(failurePut, e, referralSlice.actions.getReferralInvitedFriendsError);
    }
}

export function* getReferralQRCodeSaga() {
    const qrCodeData = yield select(getReferralQRCodeSelector);
    const referralLink = yield select(getReferralLinkSelector);

    if (!qrCodeData) {
        try {
            yield put(referralSlice.actions.getReferralQRCodeStart());
            const genData = yield call(QRCode.toDataURL as any, referralLink, { width: 240 });
            yield put(referralSlice.actions.getReferralQRCodeSuccess(genData));
        } catch (e) {
            yield put(referralSlice.actions.getReferralQRCodeError('referral.error_generate_qr_code_ref_link'));
        }
    }
}

export function* getReferralSaga() {
    try {
        const resp = yield call(getRequest, '/referral/referral-status');
        yield put(referralSlice.actions.getReferralSuccess(resp));
    } catch (e) {
        yield call(failurePut, e, referralSlice.actions.getReferralError);
    }
}

export function* getReferrerRewardBalanceSaga() {
    try {
        const resp = yield call(getRequest, '/referral/referrer-reward-balance');
        yield put(referralSlice.actions.getReferrerRewardBalanceSuccess(resp));
    } catch (e) {
        yield call(failurePut, e, referralSlice.actions.getReferrerRewardBalanceError);
    }
}

export function* addFundsToReferrerSaga() {
    try {
        const resp = yield call(postRequest, '/referral/receive-reward');
        yield put(referralSlice.actions.addFundsToReferrerSuccess(resp));
        yield put(locationSlice.actions.addLocationAction({ name: LOCATION_NAMES.REFERRAL_GIFT_REWARD }));
    } catch (e) {
        yield call(failurePut, e, referralSlice.actions.addFundsToReferrerError);
    }
}

export function* referralSagas() {
    yield takeEvery(referralSlice.actions.getReferralCodeAction, getReferralCodeSaga);
    yield takeEvery(referralSlice.actions.getReferralInvitedFriendsAction, getReferralInvitedFriendsSaga);
    yield takeEvery(referralSlice.actions.getReferralQRCodeAction, getReferralQRCodeSaga);
    yield takeEvery(referralSlice.actions.getReferralAction, getReferralSaga);
    yield takeEvery(referralSlice.actions.getReferrerRewardBalanceAction, getReferrerRewardBalanceSaga);
    yield takeEvery(referralSlice.actions.addFundsToReferrerAction, addFundsToReferrerSaga);
}